import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from '../features/auth/authSlice';
import { baseApi } from '../services/baseApi';
// Import feature slices so their `injectEndpoints` calls register on the base API.
import '../features/auth/authApi';
import '../features/organizations/organizationsApi';
import '../features/territory/territoryApi';
import '../features/aiPlanner/plannerApi';
import '../features/dataSync/dataSyncApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
